import { useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from '@/components/ui/dropdown-menu';
import { Menu, ChevronRight, Phone } from 'lucide-react';

const links = [
  { label: 'Home', path: '/' },
  { label: 'Book a CarLens Inspection · from $199', path: '/book' },
  { label: 'CarLens FirstLook™ · Consultation ($49)', path: '/firstlook' },
  { label: 'Used Car Buyer Toolkit™ · $19', path: '/used-car-buyer-toolkit' },
  { label: 'Our Services', path: '/services' },
  { label: 'Service Areas', path: '/locations' },
  { label: 'Out-of-State Car Inspection', path: '/out-of-state-car-inspection' },
  { label: 'CarLens Academy', path: '/academy' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Contact Us', path: '/contact' },
];

export const GlobalMenu = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed top-4 left-4 z-[60]">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-semibold px-4 py-2.5 rounded-full shadow-lg shadow-orange-500/30 transition-colors"
            data-testid="global-menu-btn"
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
            <span className="hidden sm:inline">Menu</span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-64 bg-zinc-900 border-zinc-800">
          <a
            href="tel:+13213003256"
            className="flex items-center gap-2 mx-1 my-1 px-3 py-2.5 rounded-md bg-orange-500/15 border border-orange-500/40 text-orange-300 font-bold hover:bg-orange-500/25 transition-colors"
            data-testid="menu-call-link"
          >
            <Phone className="w-4 h-4" /> Call 321.300.3256
          </a>
          <DropdownMenuSeparator className="bg-zinc-800" />
          <DropdownMenuLabel className="text-zinc-400">Navigate</DropdownMenuLabel>
          {links.map((l) => (
            <DropdownMenuItem
              key={l.path + l.label}
              className="text-zinc-200 hover:text-white hover:bg-white/10 cursor-pointer"
              onClick={() => navigate(l.path)}
              data-testid={`global-menu-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`}
            >
              {l.label}
            </DropdownMenuItem>
          ))}

          <DropdownMenuSeparator className="bg-zinc-800" />

          <DropdownMenuItem
            className="text-zinc-400 hover:text-white hover:bg-white/10 cursor-pointer flex items-center justify-between"
            onClick={() => navigate('/admin')}
            data-testid="global-menu-admin"
          >
            Admin Portal <ChevronRight className="w-4 h-4" />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default GlobalMenu;
